import { Button } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VoiceraLogo from '../images/VoiceraLogo.png'
import { HelpModelComponent } from './HelpModelComponent';


export const HeaderComponent = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const handleHelpClose = () => setShow(false);
    const handleHelpShow = () => setShow(true);

    return (
        <div className='bg-light'>
            <header style={{ marginLeft: "1rem", marginRight: "1rem", display: "flex", justifyContent: "space-between" }}>

                <span style={{ display: "flex" }} onClick={() => navigate('/')}>
                    <img className='mt-2' src={VoiceraLogo} alt='Voicera Logo' height='45' width='100%' />
                </span>
                <span className='mt-2'>
                </span>
                <Button onClick={handleHelpShow}>Help?</Button>
            </header>
            <hr style={{ width: "100%", marginTop: "5px" }} />
            {
                show && <HelpModelComponent handleHelpClose={handleHelpClose} handleHelpShow={handleHelpShow} show={show} setShow={setShow} />
            }
        </div>
    )
}
